// extracted by mini-css-extract-plugin
export default {"wrapper":"NodeIndicatorConfig_wrapper__r2kIi"};